import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mt-3" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" Your screen includes ");
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" active compounds and ");
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" other compounds. ");
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h6", null, "Receiver Operating Characteristic (ROC) Curve", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", null, " The area under the receiver operating characteristic curve (AUROC) is a useful metric for evaluating the overall performance of a virtual screen, from the best-scoring compound to the worst. ", -1);
const _hoisted_8 = { class: "mb-0" };
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" The AUROC of your screen is ");
const _hoisted_10 = /*#__PURE__*/ _createTextVNode(". If you randomly select one of your active compounds and one of your other compounds, the active will have the better docking score ");
const _hoisted_11 = /*#__PURE__*/ _createTextVNode(" of the time. ");
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("h6", null, "Enrichment Factors (EF)", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", null, " An enrichment factor considers the compounds with the best docking scores. It compares the fraction of actives in a set of top-scoring compounds to the overall fraction of actives. ", -1);
const _hoisted_14 = { class: "mb-0" };
const _hoisted_15 = /*#__PURE__*/ _createTextVNode(" For example, your virtual screen included ");
const _hoisted_16 = /*#__PURE__*/ _createTextVNode(" compounds total. Of these, ");
const _hoisted_17 = /*#__PURE__*/ _createTextVNode(" (");
const _hoisted_18 = /*#__PURE__*/ _createTextVNode(" compounds) were active. But among the top ");
const _hoisted_19 = /*#__PURE__*/ _createTextVNode(" best-scoring compounds, ");
const _hoisted_20 = /*#__PURE__*/ _createTextVNode(" (");
const _hoisted_21 = /*#__PURE__*/ _createTextVNode(" compounds) were active, giving an enrichment factor of ");
const _hoisted_22 = /*#__PURE__*/ _createTextVNode(" (");
const _hoisted_23 = /*#__PURE__*/ _createTextVNode(" / ");
const _hoisted_24 = /*#__PURE__*/ _createTextVNode("). ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    const _component_Chart = _resolveComponent("Chart");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        isActionBtnEnabled: _ctx.isActionBtnEnabled,
        onOnPopupDone: _ctx.onPopupDone,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        submitOnEnter: false,
        cancelBtnTxt: "Done",
        actionBtnTxt: ""
    }, {
        afterForm: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warnings, (warning) => {
                    return (_openBlock(), _createBlock(_component_Alert, {
                        key: warning[0],
                        type: warning[1]
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(warning[0]), 1)
                        ]),
                        _: 2
                    }, 1032, ["type"]));
                }), 128))
            ]),
            (_ctx.analysisVisible)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_Alert, { type: "info" }, {
                        default: _withCtx(() => [
                            _hoisted_3,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numActives), 1),
                            _hoisted_4,
                            _createElementVNode("strong", null, _toDisplayString(_ctx.numIactives), 1),
                            _hoisted_5
                        ]),
                        _: 1
                    }),
                    _hoisted_6,
                    _createVNode(_component_Chart, {
                        xAxisLabel: "False Positive Rate",
                        yAxisLabel: "True Positive Rate",
                        xAxisLabelHover: "FPR",
                        yAxisLabelHover: "TPR",
                        xAxisUnits: "",
                        yAxisUnits: "",
                        chartData: _ctx.rocData,
                        chartType: "scatter",
                        ratio: _ctx.ratio,
                        smooth: false,
                        fillUnderLine: true
                    }, null, 8, ["chartData", "ratio"]),
                    _createVNode(_component_Alert, {
                        type: "info",
                        extraClasses: "mt-3"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_7,
                            _createElementVNode("p", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.auroc.toFixed(3)), 1),
                                _hoisted_10,
                                _createElementVNode("strong", null, _toDisplayString((_ctx.auroc * 100).toFixed(1)) + "%", 1),
                                _hoisted_11
                            ])
                        ]),
                        _: 1
                    }),
                    _hoisted_12,
                    _createVNode(_component_Chart, {
                        xAxisLabel: "Number of Top Compounds Considered",
                        yAxisLabel: "Enrichment Factor",
                        xAxisLabelHover: "Top Compounds",
                        yAxisLabelHover: "EF",
                        xPrecision: 0,
                        xAxisUnits: "",
                        yAxisUnits: "",
                        chartData: _ctx.efData,
                        chartType: "scatter",
                        ratio: _ctx.ratio,
                        smooth: false
                    }, null, 8, ["chartData", "ratio"]),
                    _createVNode(_component_Alert, {
                        type: "info",
                        extraClasses: "mt-3"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_13,
                            _createElementVNode("p", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.numActives + _ctx.numIactives), 1),
                                _hoisted_16,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.percentTotalActives) + "%", 1),
                                _hoisted_17,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.numActives), 1),
                                _hoisted_18,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.bestEFCutoff), 1),
                                _hoisted_19,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.percentTopCompoundsActive) + "%", 1),
                                _hoisted_20,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.numActivesAtBestEF), 1),
                                _hoisted_21,
                                _createElementVNode("strong", null, _toDisplayString(parseFloat(_ctx.percentTopCompoundsActive) /
                                    parseFloat(_ctx.percentTotalActives)), 1),
                                _hoisted_22,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.percentTopCompoundsActive) + "%", 1),
                                _hoisted_23,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.percentTotalActives) + "%", 1),
                                _hoisted_24
                            ])
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "isActionBtnEnabled", "onOnPopupDone", "onOnUserArgChanged"]));
}
